<template>
  <div class="quick-replies-container" v-if="showQuickReplies">
    <div class="quick-replies-header">
      <h3 class="quick-replies-title">سوالات متداول</h3>
      <button class="quick-replies-toggle" @click="$emit('toggle')" :aria-label="$t('dashboard.chat.hideQuickReplies') || 'مخفی کردن'">
        <v-icon size="18" color="#6B7FD7">mdi-chevron-down</v-icon>
      </button>
    </div>
    <div class="quick-replies-scroll" ref="quickRepliesScroll">
      <div 
        v-for="(reply, index) in displayedReplies" 
        :key="index"
        class="quick-reply-chip"
        :class="{ 
          'quick-reply-chip-sending': sendingIndex === index,
          'quick-reply-chip-disabled': sendingIndex !== null && sendingIndex !== index
        }"
        @click="handleQuickReply(reply, index)"
      >
        <v-icon :size="16" :color="reply.color || '#6B7FD7'" class="quick-reply-icon">
          {{ reply.icon }}
        </v-icon>
        <span class="quick-reply-text">{{ reply.text }}</span>
        <v-progress-circular 
          v-if="sendingIndex === index" 
          indeterminate 
          size="14" 
          width="2"
          color="#6B7FD7"
          class="quick-reply-sending-icon"
        ></v-progress-circular>
      </div>
    </div>
  </div>
  <div v-else class="quick-replies-collapsed">
    <button class="quick-replies-show-btn" @click="$emit('toggle')">
      <v-icon size="18" color="#6B7FD7">mdi-chevron-up</v-icon>
      <span>سوالات متداول</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuickReplies',
  props: {
    showQuickReplies: {
      type: Boolean,
      default: true
    },
    contextReplies: {
      type: Array,
      default: () => []
    },
    isSending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sendingIndex: null,
      predefinedReplies: [
        {
          text: 'چگونه می‌توانم جلسه رزرو کنم؟',
          icon: 'mdi-calendar-clock',
          color: '#6B7FD7',
          category: 'booking'
        },
        {
          text: 'وضعیت جلسه من چیست؟',
          icon: 'mdi-information-outline',
          color: '#6B7FD7',
          category: 'status'
        },
        {
          text: 'چگونه می‌توانم تراپیست خود را تغییر دهم؟',
          icon: 'mdi-account-switch',
          color: '#6B7FD7',
          category: 'therapist'
        },
        {
          text: 'مشکل فنی دارم',
          icon: 'mdi-tools',
          color: '#FF9800',
          category: 'technical'
        },
        {
          text: 'سوال درباره پرداخت دارم',
          icon: 'mdi-credit-card-outline',
          color: '#4CAF50',
          category: 'payment'
        },
        {
          text: 'لطفاً با من تماس بگیرید',
          icon: 'mdi-phone-outline',
          color: '#6B7FD7',
          category: 'contact'
        }
      ]
    }
  },
  computed: {
    displayedReplies() {
      // If context replies are provided, show those first, then predefined
      if (this.contextReplies && this.contextReplies.length > 0) {
        return [...this.contextReplies, ...this.predefinedReplies];
      }
      return this.predefinedReplies;
    }
  },
  methods: {
    handleQuickReply(reply, index) {
      if (this.sendingIndex !== null) return;
      
      this.sendingIndex = index;
      this.$emit('send', reply.text);
      
      // Reset sending state after animation
      setTimeout(() => {
        this.sendingIndex = null;
      }, 500);
    }
  }
}
</script>

<style scoped>
.quick-replies-container {
  background: #FFFFFF;
  border-top: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
  padding: 16px 20px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
  }
}

.quick-replies-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  direction: rtl;
}

.quick-replies-title {
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  margin: 0;
  direction: rtl;
  text-align: right;
}

.quick-replies-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
  width: 28px;
  height: 28px;
}

.quick-replies-toggle:hover {
  background: #F5F5F5;
}

.quick-replies-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
  direction: rtl;
  scrollbar-width: thin;
  scrollbar-color: #D1D1D1 #F5F5F5;
}

.quick-replies-scroll::-webkit-scrollbar {
  height: 6px;
}

.quick-replies-scroll::-webkit-scrollbar-track {
  background: #F5F5F5;
  border-radius: 10px;
}

.quick-replies-scroll::-webkit-scrollbar-thumb {
  background: #D1D1D1;
  border-radius: 10px;
}

.quick-replies-scroll::-webkit-scrollbar-thumb:hover {
  background: #BDBDBD;
}

.quick-reply-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #FAFBFC;
  border: 1.5px solid #E0E0E0;
  border-radius: 24px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  min-height: 44px;
  transition: all 0.2s ease;
  position: relative;
  direction: rtl;
  user-select: none;
}

.quick-reply-chip:hover:not(.quick-reply-chip-sending) {
  background: #F0F4FF;
  border-color: #6B7FD7;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(107, 127, 215, 0.15);
}

.quick-reply-chip:active:not(.quick-reply-chip-sending) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(107, 127, 215, 0.1);
}

.quick-reply-chip-sending {
  background: #E8EDFF;
  border-color: #6B7FD7;
  cursor: wait;
  opacity: 0.8;
}

.quick-reply-chip-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.quick-reply-icon {
  flex-shrink: 0;
}

.quick-reply-text {
  font-size: 14px;
  font-weight: 500;
  color: #424242;
  line-height: 1.4;
}

.quick-reply-sending-icon {
  animation: spin 1s linear infinite;
  margin-right: auto;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.quick-replies-collapsed {
  background: #FAFBFC;
  border-top: 1px solid #E0E0E0;
  padding: 8px 20px;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.quick-replies-show-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 16px;
  transition: background 0.2s ease;
  direction: rtl;
  color: #6B7FD7;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  justify-content: center;
}

.quick-replies-show-btn:hover {
  background: #F0F4FF;
}

/* Mobile optimizations */
@media (max-width: 600px) {
  .quick-replies-container {
    padding: 12px 16px;
  }
  
  .quick-reply-chip {
    padding: 10px 14px;
    min-height: 44px;
    font-size: 13px;
  }
  
  .quick-replies-title {
    font-size: 13px;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .quick-replies-container,
  .quick-replies-collapsed,
  .quick-reply-chip {
    animation: none;
    transition: none;
  }
  
  .quick-reply-sending-icon {
    animation: none;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .quick-reply-chip {
    border-width: 2px;
  }
  
  .quick-reply-chip:hover {
    border-width: 3px;
  }
}
</style>

